import axios from 'axios';
import Util from './utils'
// 创建axios实例
const service = axios.create({
});


// request拦截器
service.interceptors.request.use(
  config => {
    // 请求头加上当前域名
    let _token = Util.getToken();
    config.headers['Accept'] = 'application/json'
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    config.headers['If-Modified-Since'] = 0
    if (_token) {
      config.headers['LB-WEB-Authentication'] = _token; // 让每个请求携带自定义token 请根据实际情况自行修改 // change by wen hao
    }
    // 解决IE下，get请求的缓存问题
    config.params = {
      _t: Date.now(),
      ...(config.params || {})
    }

    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  response => {
    // const res = response.data;
    // if (response.headers) {
    //   if (parseInt(res.code) == 2010) {
    //     return;
    //   }
    // }
    // if (parseInt(res.code) !== 2000) {
    //   // LoadingUtil.hideLoading();
    //   if (parseInt(res.code) === 4030) {
    //     console.log(res.code)
    //   } else if (parseInt(res.code) === 4050) {
    //     // 没有权限
    //     return Promise.reject(res);
    //   }
    // }
    return response.data;
  },
  error => {
    console.log('err' + error); // for debug 网络请求出错，可能服务器挂了之类的
    return Promise.reject(error);
  }
);

export default service;
